/*
* Copyright (C) Regione Lombardia
*/
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Paginator, Sorting, SortingDirectionEnum } from '@models';
import { AnagraficaService } from '@shared/services/anagrafica.service';
import { OperaService } from '@shared/services/opera.service';
import { ProgettoService } from '@shared/services/progetto.service';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GestioneProgettoDettaglioProgettoResolver implements Resolve<Observable<any>> {
    
    public paginator: Paginator = new Paginator();
    public tableSort: Sorting[] = [
        { field: 'idOpera', direction: SortingDirectionEnum.EMPTY },
        { field: 'denProv', direction: SortingDirectionEnum.EMPTY },
        { field: 'denComune', direction: SortingDirectionEnum.EMPTY },
    ];

    constructor(
        private progettoService: ProgettoService,
        private anagraficaService: AnagraficaService,
        private operaService: OperaService
    ) { }



    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return forkJoin([
            this.progettoService.read(route.params['idProgetto']),
            this.progettoService.documentoProgettoByIdProgetto(route.params['idProgetto']),
            this.progettoService.leggiProgettoByIdProgetto(route.params['idProgetto']),
            this.operaService.search({idProgetto: route.params['idProgetto'], trattoIdrico: null, codProv: null, comune: null, codIstat: null, idMaterialeCostruzione: null, idOpera: null, idStato: null, idTipoIntervento: null, idTipologiaOpera: null, provenienza: null }, this.paginator.getQueryPaginator(this.tableSort)),
            this.anagraficaService.getClasseDocumento(),
            this.anagraficaService.getLegge(),
            this.anagraficaService.getMacroTipologiaOpera(),
            this.anagraficaService.getTipologiaOpera(),
            this.anagraficaService.getMateriale(),
            this.anagraficaService.getStatoOpera(),
        ]).pipe(
            map(([
                responseProgetto,
                responseDocumentoProgetto,
                responseLeggiProgetto,
                responseOpereAssociate,
                responseAnagraficaClasseDocumento,
                responseAnagraficaLegge,
                responseAnagraficaMacroTipologiaOpera,
                responseAnagraficaTipologiaOpera,
                responseAnagraficaMateriale,
                responseAnagraficaStatoOpera,
            ]) => {
                this.progettoService.progettoSession = responseProgetto;
                return {
                    progetto: responseProgetto,
                    leggiProgetto: responseLeggiProgetto,
                    documentoProgetto: responseDocumentoProgetto,
                    opereAssociate: responseOpereAssociate,
                    datalist: {
                        classeDocumento: responseAnagraficaClasseDocumento,
                        legge: responseAnagraficaLegge,
                        macroTipologiaOpera: responseAnagraficaMacroTipologiaOpera,
                        materiale: responseAnagraficaMateriale,
                        statoOpera: responseAnagraficaStatoOpera,
                        tipologiaOpera: responseAnagraficaTipologiaOpera,
                    },
                };
            }),
        );
    }

}